import { CSVLink } from "react-csv";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { crossSellRecommendationData } from "../../services/interfaces/ICrossSellOpportunity";
import { numberFormatter } from "../../utils/formatter";
import { Checkbox } from "rsuite";
import { useEffect, useState } from "react";

const CrossSellRecommendations = ({
  crossellSKULevelDataCopy,
  updateSKULevelData,
  selectedItemID,
  updateSaveButton,
  selectedCustomerId,
  selectedPeerName,
  selectedItem,
  updateSKUData,
  isFilterExpanded,
}: any) => {
  const removeLeadingZero = (n: any) => {
    let newStr = n?.replace(/^0+/, "");
    return newStr;
  };

  const [selectedUpdateData, setSelectedUpdateData] = useState<Array<string | null>>([])

  useEffect(() => {
    setSelectedUpdateData(updateSKUData)
  }, [updateSKUData])

  const handleCheckboxSelection = (data: any, value: number) => {
    updateSaveButton(true);
    let finalData = JSON.parse(JSON.stringify(selectedUpdateData))
    let index = finalData?.findIndex((val: any) => val?.sku2 === data?.sku2)
    if (index !== -1) {
      finalData[index].accept_ind = value === 1 ? 0 : 1
      finalData[index].marked = false
    } else {
      let obj = {
        accept_ind: data?.accept_ind === 1 ? 0 : 1,
        customer: selectedCustomerId,
        itemid: selectedItem,
        peerGroupName: selectedPeerName,
        sku2: data?.sku2,
        OpportunityMargin: data?.OpportunityMargin,
        marked: false,
        priority_group_flag: data?.priority_group_flag
      }
      finalData.push(obj)
    }
    updateSKULevelData(finalData);
  }



  return (
    <div className="h-full w-full">
      <div className="business-cost-trend-table mt-[0]">
        <DataTable
          className="h-full w-full"
          value={
            crossellSKULevelDataCopy && selectedItemID ? crossellSKULevelDataCopy : []
          }
          stripedRows
          scrollable
          scrollHeight={isFilterExpanded ? "58vh" : "66vh"}
          showGridlines
          emptyMessage="No Data Found"
        >
          <Column
            field="priority_group_flag"
            header="Priority"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>{rowdata.priority_group_flag}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="sku2_l3"
            header="Category"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>{rowdata.sku2_l3}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="sku2"
            header="Item ID"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="flex-col justify-start items-center">
                  {rowdata?.SKU2_ImageLink !== 'NA' && rowdata?.SKU2_ImageLink && <img
                    src={rowdata?.SKU2_ImageLink}
                    alt="item-logo"
                    className="w-[7vh] h-[6vh] mb-[.5vh]"
                  />}
                  <span>{removeLeadingZero(rowdata.sku2)}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="SKU2_Master_Vendor_Name"
            header="Supplier"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>{rowdata.SKU2_Master_Vendor_Name}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="sku2_desc"
            header="Item Desc"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>{rowdata.sku2_desc}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="OpportunityQty"
            header="Qty"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>{numberFormatter(rowdata.OpportunityQty, 0)}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="OpportunityMargin"
            header="Benefit"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>
                    {numberFormatter(rowdata.OpportunityMargin, 0, "$")}
                  </span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="accept_ind"
            header="Accept"
            headerClassName="table-header-text"
            body={(rowdata: crossSellRecommendationData) => {
              return (
                <div className="table-cell-text flex justify-start items-center">
                  <span>
                    <Checkbox key={rowdata?.sku2} defaultChecked={rowdata?.accept_ind === 1 ? true : false} value={rowdata?.accept_ind} color="green"
                      onChange={(value: any) => {

                        handleCheckboxSelection(rowdata, value);
                      }
                      }
                    >
                    </Checkbox>
                  </span>
                </div>
              );
            }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default CrossSellRecommendations;
